export const fr = {
  langSwitcher: {
    label: 'Langue',
    fr: 'Français',
    en: 'English',
    nl: 'Nederlands',
  },
  notFound: {
    title: 'Page introuvable',
    body: "La page que vous cherchez n'existe pas ou a été déplacée.",
    cta: "Retour à l'accueil",
  },
  legalLayout: {
    home: 'Accueil',
    lastUpdated: 'Dernière mise à jour',
  },
  footer: {
    tagline:
      "Votre plateforme pour gérer toute votre logistique e-commerce. Entrepôt au cœur de l'Europe, équipe francophone.",
    colProduct: 'Produit',
    colCompany: 'Société',
    colResources: 'Ressources',
    colLegal: 'Légal',
    linkSectors: 'Secteurs',
    linkFulfillment: 'Fulfillment DNVB & D2C',
    linkPricing: 'Tarifs',
    linkStorage: 'Stockage',
    linkPickpack: 'Pick & Pack',
    linkShipping: 'Expédition 24h',
    linkReturns: 'Retours',
    linkCarriers: 'Transporteurs',
    linkAdr: 'Stockage ADR',
    linkAfsca: 'Stockage AFSCA',
    linkAbout: 'À propos',
    linkBlog: 'Blog',
    linkContact: 'Contact',
    linkFaq: 'FAQ',
    linkIntegrations: 'Intégrations',
    linkTestimonials: 'Témoignages',
    linkLegalNotice: 'Mentions légales',
    linkTerms: 'CGV',
    linkPrivacy: 'Politique de confidentialité',
    linkCookies: 'Politique cookies',
    socialAria: 'Yaslan sur {name}',
    manageCookies: 'Gérer les cookies',
    systemsOperational: 'Tous systèmes opérationnels',
  },
  nav: {
    cta: 'Parler à un expert',
    openMenu: 'Ouvrir le menu',
    closeMenu: 'Fermer le menu',
    menuServices: 'Services',
    menuSecteurs: 'Secteurs',
    menuRessources: 'Ressources',
    menuExpertises: 'Expertises',
    colParService: 'Par service',
    colOutils: 'Outils',
    colModeBeaute: 'Mode & Beauté',
    colMaisonOutdoor: 'Maison & Outdoor',
    colLecture: 'Lecture',
    colSociete: 'Société',
    storageLabel: 'Stockage',
    storageDesc: 'Entrepôt européen flexible',
    pickpackLabel: 'Pick & Pack',
    pickpackDesc: 'Préparation à votre image',
    shippingLabel: 'Expédition 24h',
    shippingDesc: 'Cut-off à 15h, livré demain',
    returnsLabel: 'Retours',
    returnsDesc: 'Portail marque blanche',
    fulfillmentLabel: 'Fulfillment DNVB & D2C',
    fulfillmentDesc: 'La logistique des marques D2C',
    pricingLink: 'Tarifs',
    integrationsLabel: 'Intégrations',
    integrationsDesc: 'Shopify, WooCommerce, Amazon',
    carriersLabel: 'Transporteurs',
    carriersDesc: '30+ partenaires comparés',
    modeLabel: 'Mode & Textile',
    modeDesc: 'Drops, retours, branding',
    cosmetiqueLabel: 'Cosmétique & Beauté',
    cosmetiqueDesc: 'Lots, conformité CLP, kits',
    parfumerieLabel: 'Parfumerie',
    parfumerieDesc: 'ADR, flacons, coffrets',
    maisonLabel: 'Maison & Décoration',
    maisonDesc: 'Fragilité, multi-colis',
    jardinLabel: 'Jardin & Extérieur',
    jardinDesc: 'Volumes, ultra-saisonnier',
    electroniqueLabel: 'Électronique & High-Tech',
    electroniqueDesc: 'Sérialisation, RMA, ADR',
    blogLabel: 'Blog',
    blogDesc: 'Études de cas et guides',
    faqLabel: 'FAQ',
    faqDesc: 'Questions fréquentes',
    aboutLabel: 'À propos',
    aboutDesc: "Notre raison d'être",
    contactLabel: 'Contact',
    contactDesc: 'Parlez à un expert',
    colExpertise: 'Agréments & capacités',
    adrLabel: 'ADR — Marchandises dangereuses',
    adrDesc: 'Stockage & expédition sous permis ADR',
    afscaLabel: 'AFSCA — Alimentaire',
    afscaDesc: 'Stockage ambiant enregistré AFSCA',
  },
  hero: {
    badgeAutopilot: 'Logistique en autopilote',
    badgeWarehouse: "Entrepôt au cœur de l'Europe",
    headlineLine1Part1: 'Votre',
    headlineLine1Part2: 'logistique',
    headlineLine1Part3: 'e-commerce,',
    headlineLine2Part1: 'fluide, fiable',
    headlineLine2Part2: 'et',
    headlineLine2Part3: 'discrète.',
    subhead:
      'Stockage, pick & pack, expédition en 24h via 30+ transporteurs et gestion des retours — sans abonnement, sans friction. Vos colis, votre marque, notre logistique.',
    ctaPrimary: 'Demander un devis',
    ctaSecondary: 'Calculer votre tarif',
    ctaReassurance: 'Audit gratuit en 2 minutes · Sans abonnement',
    trustDelivery: 'Livraison en 1-2 jours',
    trustAllLevels: 'Adapté aux débutants comme aux experts',
    trustNoCommitment: 'Sans engagement',
    trustReturns: 'Retours 100 % automatisés',
  },
  cta: {
    badge: 'Audit logistique gratuit',
    headlinePart1: 'Prêt à déléguer',
    headlinePart2: 'votre logistique',
    subhead:
      'Parlez à un expert Yaslan. On analyse votre setup actuel, on vous montre combien vous pourriez économiser, et on vous lance en 15 minutes.',
    ctaPrimary: 'Réserver un échange de 30 min',
    ctaSecondary: 'Découvrir les services',
    trustResponse: 'Réponse sous 24h ouvrées',
    trustPayAsYouGo: "Paiement à l'usage",
    trustOnboarding: 'Onboarding 15 min',
    trustSupport: 'Support FR/EN 7h-22h',
  },
  closing: {
    badge: 'Notre engagement · Logistique invisible',
    headlinePart1: 'Une logistique qui',
    headlinePart2: 'se fait oublier',
    subhead:
      'La meilleure logistique e-commerce est celle que personne ne remarque, sauf vous. Trois engagements qui guident chacun de nos choix, du premier carton réceptionné à la dernière notification de livraison.',
    promiseInvisibleTitle: 'Discrète',
    promiseInvisibleDesc:
      'Vos clients ne voient jamais notre nom. Packaging, portail de retours et e-mails restent à votre marque, du carton au mail de confirmation.',
    promiseFlexibleTitle: 'Flexible',
    promiseFlexibleDesc:
      "Pas d'abonnement, pas d'engagement long, pas de minimum. Vous payez ce que vous expédiez réellement, et votre tarif évolue avec votre activité.",
    promiseHumanTitle: 'Humaine',
    promiseHumanDesc:
      'Une équipe francophone basée en Belgique, joignable directement, qui connaît vos produits et vos contraintes — pas un chatbot, pas un ticket.',
  },
  stats: {
    eyebrow: 'Des chiffres concrets',
    headline: 'La logistique qui suit votre croissance.',
    shippingLabel: 'Expédition max',
    shippingSub: 'Commandes avant 15h',
    carriersLabel: 'Transporteurs',
    carriersSub: 'GLS, bpost, DPD, UPS...',
    platformsLabel: 'Plateformes',
    platformsSub: 'Shopify, WooCommerce, Odoo',
    savingsLabel: 'Transparence',
    savingsSub: "Transport + pick & pack, c'est tout",
  },
  brands: {},
  carriers: {
    badgeLabel: 'Transporteurs',
    badgeCount: '+30 intégrations natives',
    headlinePart1: 'Une intégration,',
    headlinePart2: '+30 transporteurs',
    headlinePart3: 'zéro friction.',
    subhead:
      'Bpost, DHL, GLS, UPS, DPD… Nous comparons les tarifs et éditons les étiquettes. Vous suivez chaque colis depuis un seul tableau de bord.',
    featured: 'En vedette',
    negotiatedRates: 'Tarifs négociés',
    moreCarriersLine1: 'Encore plus de',
    moreCarriersLine2: 'transporteurs',
    zoneWorld: 'Monde',
    leadBpost: 'Livraison standard et rapide (24h) en Belgique.',
    leadGls:
      'Livraison de colis fiable avec une forte couverture européenne B2C et B2B.',
    leadDhl: "Le spécialiste de la livraison express à l'international.",
    leadDpd:
      'Réseau européen solide offrant des options de livraison flexibles.',
    leadPostnl:
      "L'opérateur principal pour vos expéditions vers les Pays-Bas et le Benelux.",
    leadUps: 'Transport mondial rapide avec un suivi très précis.',
    leadFedex: 'Livraison express mondiale pour vos expéditions urgentes.',
    leadMondialrelay:
      'Solution économique spécialisée dans la livraison en points relais.',
    leadColisprive: 'Livraison à domicile optimisée pour le e-commerce.',
    leadDeutschepost:
      "Service postal classique et économique pour l'Allemagne et l'international.",
    leadDsv:
      'Solutions logistiques mondiales et transport de fret (routier, maritime, aérien).',
  },
  services: {
    badgeLabel: 'Services',
    badgeTagline: 'Logistique de bout en bout',
    headlinePart1: 'Une plateforme qui gère',
    headlinePart2: 'toute votre logistique',
    subhead:
      'De la réception du produit à la livraison finale — et au-delà avec les retours — Yaslan couvre chaque étape, en autopilote.',
    learnMore: 'En savoir plus',
    storageTitle: 'Stockage',
    storageDesc:
      "Entreposage e-commerce centralisé au cœur de l'Europe, scalable sans volume minimum.",
    storageBullet1: 'Réception & contrôle',
    storageBullet2: 'Stock temps réel',
    storageBullet3: 'Racks, palettes & bacs picking',
    pickpackTitle: 'Pick & Pack',
    pickpackDesc:
      'Préparation automatisée avec emballages 100% personnalisables à votre marque.',
    pickpackBullet1: 'Branding sur mesure',
    pickpackBullet2: 'Encartage promo',
    pickpackBullet3: 'Préparation < 4 h',
    shippingTitle: 'Expédition 24h',
    shippingDesc:
      '30+ transporteurs comparés automatiquement. Commandes avant 15h expédiées le jour même.',
    shippingBullet1: 'Cut-off à 15h',
    shippingBullet2: 'Routing intelligent',
    shippingBullet3: 'Tracking unifié',
    returnsTitle: 'Retours gérés',
    returnsDesc:
      'Traitement complet selon vos règles. Réintégration stock, remboursement ou revente.',
    returnsBullet1: 'Portail client en marque blanche',
    returnsBullet2: 'Règles personnalisables',
    returnsBullet3: 'Remise en stock 24 h',
  },
  features: {
    badgeLabel: 'Pourquoi Yaslan',
    badgeTagline: 'Une logistique invisible',
    headlinePart1: 'Zéro friction.',
    headlinePart2: 'Zéro surveillance.',
    subhead:
      'Une logistique pensée pour disparaître : vous vendez, nous livrons — vos clients ne voient que votre marque.',
    carriersName: '30+ transporteurs',
    carriersDesc:
      'GLS, bpost, DPD, UPS, DHL, PostNL… comparés et sélectionnés automatiquement, commande par commande.',
    carriersHighlight: 'Multi-carrier',
    carriersCta: 'Voir les intégrations',
    tariffName: 'Tarifs alignés à votre volume',
    tariffDesc:
      "Que vous expédiez 100 ou 5 000 colis par mois, vos tarifs s'ajustent naturellement à votre activité.",
    tariffHighlight: 'Pricing dynamique',
    packagingName: 'Packaging à ta marque',
    packagingDesc: 'Cartons, pochettes, inserts, notices — 100% personnalisables.',
    packagingHighlight: 'Brand-first',
    savingsName: 'Un prix tout compris',
    savingsDesc:
      'Transport + pick & pack en un seul prix par commande — dégressif selon votre volume.',
    savingsHighlight: 'Transparence',
    savingsStrike1: 'Réception & mise en stock',
    savingsStrike2: 'Stockage',
    savingsStrike3: 'Abonnement WMS',
    savingsTotalLabel: 'Transport + pick & pack',
    savingsTotalBadge: '1 prix',
    supportName: 'Support FR/EN 7h-22h',
    supportDesc: 'Équipe francophone dédiée. Audit logistique gratuit.',
    supportHighlight: 'Humain',
    supportBadge: '2h27',
    supportBadgeLabel: 'réponse moyenne',
  },
  integrations: {
    badgeLabel: 'Intégrations',
    badgeTagline: 'Hub central temps réel',
    headlinePart1: "Yaslan s'intègre",
    headlinePart2: 'à votre stack',
    headlinePart3: 'et orchestre',
    headlinePart4: 'vos livraisons',
    subhead:
      "16 plateformes e-commerce se synchronisent en temps réel. 30+ transporteurs s'activent automatiquement. Un seul hub, zéro config.",
    hubLabel: 'Hub Yaslan',
    benefitNoCodeTitle: 'Aucune ligne de code',
    benefitNoCodeDesc:
      'Connectez votre stack en 3 clics depuis le tableau de bord. Aucun dev requis.',
    benefitFailoverTitle: 'Failover transporteur',
    benefitFailoverDesc:
      "Si un transporteur tombe, bascule automatique vers le suivant en moins d'1 seconde.",
    benefitWebhooksTitle: 'Webhooks temps réel',
    benefitWebhooksDesc:
      'Chaque événement (commande, scan, livraison) déclenche vos automatisations à la milliseconde.',
  },
  faq: {
    eyebrow: 'Questions fréquentes',
    heading: "Tout ce qu'il faut savoir.",
    q1: 'Qu\'est-ce que Yaslan Logistique ?',
    a1: "Yaslan est un prestataire logistique 3PL basé en Belgique, spécialisé dans l'e-commerce. Nous stockons vos produits, préparons et expédions vos commandes, et gérons les retours — pour que vous vous concentriez sur la vente.",
    q2: 'À qui s\'adresse Yaslan ?',
    a2: "Aux boutiques e-commerce de toutes tailles : des premières ventes jusqu'aux marques scalant plusieurs milliers de commandes par mois. Pas de volume minimum requis.",
    q3: 'Comment se passe l\'onboarding ?',
    a3: "En 15 minutes : nous connectons votre boutique (Shopify, WooCommerce, etc.), nous recevons votre stock, et vos premières commandes partent en 24h. Onboarding guidé par un expert dédié.",
    q4: 'Quels sont les délais d\'expédition ?',
    a4: "Toute commande passée avant 15h est préparée et expédiée le jour même. Vous choisissez le transporteur par défaut ou nous laissez optimiser automatiquement.",
    q5: 'Comment fonctionne la gestion des retours ?',
    a5: "Vous définissez les règles (réintégration, remboursement, destruction, revente). À la réception, nous traitons chaque retour selon vos critères et mettons à jour votre stock.",
    q6: 'Mes emballages peuvent-ils être personnalisés ?',
    a6: "Oui, 100%. Cartons, pochettes, papier de soie, inserts, stickers, notices — tout peut porter votre marque. Vous nous envoyez vos éléments, nous les intégrons à la préparation.",
    q7: 'Quelle est la tarification ?',
    a7: "Paiement à l'usage, sans abonnement mensuel. Vous ne payez que deux choses : le transport et le pick & pack de chaque commande expédiée, en un seul prix tout compris dès 6,25 € HTVA. Réception, mise en stock, stockage, dashboard et intégrations sont inclus, sans frais. Le prix ne varie qu'avec le poids du colis, votre volume mensuel et la taille de votre catalogue.",
    q8: 'Avec quelles plateformes e-commerce vous intégrez-vous ?',
    a8: "Shopify, WooCommerce, Amazon, PrestaShop, bol, BigCommerce, eBay, Etsy, Lightspeed, Magento, Odoo, Squarespace, Temu, TikTok Shop, Wix et Decathlon. La synchronisation des commandes, du stock et des statuts d'expédition est temps réel — sans développement de votre côté.",
    q9: 'Quels transporteurs sont disponibles depuis Yaslan ?',
    a9: "30+ transporteurs intégrés : bpost, DHL, UPS, FedEx, GLS, DPD, Mondial Relay, PostNL, Colis Privé, DSV, Deutsche Post — entre autres. Notre routing automatique choisit le meilleur compromis prix/délai/zone selon vos règles.",
    q10: 'Yaslan est-il adapté aux marques internationales ?',
    a10: "Oui — notre entrepôt belge dessert toute l'Union européenne en 24-72 h. Nous expédions également au Royaume-Uni et en Suisse avec la documentation douanière incluse. Nous ne desservons pas les destinations en dehors de l'Europe (États-Unis, Asie, etc.) — seuls le territoire européen, le Royaume-Uni et la Suisse sont couverts.",
    q11: 'Comment Yaslan protège-t-il mes données et mon stock ?',
    a11: "Entrepôt sous vidéosurveillance 24/7 avec accès biométrique, scellés inviolables sur cartons sortants, sauvegardes chiffrées des données client, conformité RGPD. Inventaires hebdomadaires automatisés et accès complet à votre dashboard.",
    q12: 'Puis-je changer de prestataire si Yaslan ne me convient pas ?',
    a12: "Aucun engagement de durée. Vous récupérez votre stock et vos données quand vous le souhaitez. Nous facilitons même la migration vers un autre 3PL — historique, données produit, fiches transporteur — pour que vous gardiez la main.",
  },
  appMockup: {
    statusInTransit: 'En transit',
    statusDelivered: 'Livré',
    statusPreparing: 'Préparation',
    splashTagline: 'Logistique',
    loadingTitle: 'Synchronisation des transporteurs',
    loadingCarriers: 'GLS · bpost · DPD · UPS · DHL · PostNL...',
    notifDeliveredTitle: 'Colis livré',
    notifDeliveredSub: 'YSL-8411 — Bruxelles',
    notifOrdersTitle: '+12 commandes',
    notifOrdersSub: 'synchronisées depuis Shopify',
    navDashboard: 'Dashboard',
    navShipments: 'Expéditions',
    navReturns: 'Retours',
    navStock: 'Stocks',
    navCarriers: 'Transporteurs',
    navIntegrations: 'Intégrations',
    sidebarWarehouse: 'Entrepôt · Belgique',
    sidebarOperational: 'Opérationnel',
    topbarDate: 'Mercredi 23 avril',
    topbarTitle: "Vue d'ensemble",
    topbarSearch: 'Rechercher',
    topbarLive: 'Live',
    kpiShipments24h: 'Expéditions 24h',
    kpiInTransit: 'En transit',
    kpiDelivered: 'Livrées',
    kpiReturns: 'Retours',
    shipmentsTitle: 'Expéditions en cours',
    shipmentsRealtime: 'Temps réel',
    routesTitle: 'Routes actives',
    routesRegion: 'Europe',
    carriersTitle: 'Transporteurs',
    carriersWindow: '24h',
    hubLabel: 'BE · Hub',
  },
  about: {
    breadcrumbHome: 'Accueil',
    breadcrumbCurrent: 'À propos',
    heroBadge: "À propos · Notre raison d'être",
    heroTitlePart1: 'Libérer les entrepreneurs de',
    heroTitleHighlight: 'la logistique',
    heroSubtitle:
      "Bâtir l'opérateur logistique que les marques ambitieuses méritaient : rapide, flexible, transparent — et invisible aux yeux du client final.",
    number1Value: '30+',
    number1Label: 'Marques accompagnées',
    number2Value: '0 €',
    number2Label: 'Frais cachés',
    number3Value: '< 4h',
    number3Label: 'Cut-off préparation',
    number4Value: '99,7%',
    number4Label: 'Expédition à temps',
    convictionLabel: 'Notre conviction',
    convictionQuotePart1: 'La logistique ne doit jamais être un',
    convictionQuoteHighlight1: 'frein à la croissance',
    convictionQuotePart2: 'mais au contraire un',
    convictionQuoteHighlight2: 'moteur',
    convictionAuthor: '— Les fondateurs de Yaslan',
    storyBadge: 'Notre origine',
    storyTitlePart1: "L'idée qui a",
    storyTitleHighlight: 'tout changé',
    storyParagraph1:
      "Pendant des années, nous avons vu des marques talentueuses ralenties par les mêmes obstacles : contrats verrouillés, frais cachés, transporteurs muets, supports introuvables après 18h. Une logistique pensée pour elle-même, pas pour ceux qui la subissaient.",
    storyQuotePart1: "Et si on construisait l'opérateur que",
    storyQuoteHighlight: 'nous-mêmes',
    storyQuotePart2: 'aurions voulu trouver ?',
    storyParagraph2Part1:
      "Yaslan est cette réponse. Un service qui s'efface devant la marque, qui s'adapte au volume sans contrainte, qui répond en français — à l'heure, sans jargon. Pas une plateforme de plus.",
    storyParagraph2Highlight: "L'opérateur que nous aurions voulu avoir.",
    methodBadge: 'Notre méthode · 4 étapes',
    methodTitlePart1: 'De la connexion à',
    methodTitleHighlight: "l'optimisation",
    step1Title: 'Connexion',
    step1Desc:
      'Synchronisation automatique avec Shopify, WooCommerce, Prestashop, Amazon en quelques minutes.',
    step2Title: 'Réception',
    step2Desc:
      'Contrôle qualité, comptage, mise en stock. Vos produits sont prêts sous 24 heures.',
    step3Title: 'Expédition',
    step3Desc: 'Picking, emballage, étiquetage. Cut-off à 15h, livraison dès le lendemain.',
    step4Title: 'Optimisation',
    step4Desc:
      'Suivi des volumes et des coûts, ajustements continus pour faire baisser votre facture.',
    valuesBadge: 'Ce qui nous guide',
    valuesTitlePart1: 'Trois principes,',
    valuesTitleHighlight: 'zéro compromis',
    value1Title: 'Humain',
    value1Desc:
      'Une équipe francophone, joignable, qui connaît votre marque et vos produits.',
    value2Title: 'Flexible',
    value2Desc:
      "Pas de minimum, pas d'engagement long. Du premier colis aux milliers qui suivront.",
    value3Title: 'Transparent',
    value3Desc:
      'Tarifs clairs au m³ et au colis, dashboard temps réel, aucune ligne cachée.',
    ctaBadge: 'Onboarding 2026 · places limitées',
    ctaTitlePart1: 'Et si votre logistique',
    ctaTitleHighlight: 'disparaissait',
    ctaTitlePart2: 'de votre quotidien ?',
    ctaSubtitle:
      "30 minutes pour comprendre votre flux. Une proposition tarifaire chiffrée sous 48h. Une mise en route en moins d'une semaine.",
    ctaPrimary: 'Réserver un échange de 30 min',
    ctaSecondary: 'Découvrir les services',
    ctaTrust1: 'Réponse sous 24h ouvrées',
    ctaTrust2: 'Sans engagement',
    ctaTrust3: '30+ marques nous font confiance',
  },
  contactPage: {
    breadcrumbHome: 'Accueil',
    breadcrumbCurrent: 'Contact',
    badge: 'Contact · Parlons logistique',
    titlePart1: 'Construisons ensemble',
    titleHighlight: 'votre logistique',
    subtitlePart1: 'Dites-nous ce dont vous avez besoin. Nous revenons vers vous en',
    subtitleHighlight: 'moins de 4 heures ouvrées',
    subtitlePart2:
      ', avec une première analyse de votre flux et un ordre de grandeur tarifaire.',
    responseTitle: 'Réponse sous 4h ouvrées',
    responseDesc:
      'Du lundi au vendredi, de 7h à 22h. Notre équipe francophone répond en moyenne en 2h27.',
    emailLabel: 'E-mail',
    addressLabel: 'Adresse',
    addressLine: 'Schoondonkweg 18 bus 16, 2830 Willebroek',
    addressCountry: 'Belgique',
    followLabel: 'Suivez-nous',
    followDesc: "Coulisses, retours d'expérience",
    fieldNameLabel: 'Nom complet',
    fieldNamePlaceholder: 'Ex. Camille Dubois',
    fieldEmailLabel: 'E-mail professionnel',
    fieldEmailPlaceholder: 'vous@marque.com',
    fieldPhoneLabel: 'Numéro de téléphone',
    fieldPhonePlaceholder: '+32 xxx xx xx xx',
    fieldVolumeLabel: 'Volume mensuel estimé',
    fieldVolumePlaceholder: 'Ex. 500 commandes',
    fieldStorageLabel: 'Besoin de stockage estimé',
    fieldStoragePlaceholder: 'Ex. 30 m³',
    serviceLabel: 'Type de service',
    selectPlaceholder: 'Sélectionnez votre choix',
    option1: 'Stockage seulement',
    option2: 'Stockage + préparation',
    option3: 'Stockage + préparation + expédition',
    option4: 'Migration depuis un autre 3PL',
    option5: 'Autre',
    messageLabel: 'Expliquez votre projet',
    messagePlaceholder:
      'Produits, marchés, transporteurs actuels, contraintes spécifiques…',
    privacyPart1: 'En soumettant ce formulaire vous acceptez notre',
    privacyLink: 'politique de confidentialité',
    privacyPart2: '. Aucun spam, aucune revente, jamais.',
    submitting: 'Envoi en cours…',
    submit: 'Envoyer ma demande',
    errorGeneric: 'Une erreur est survenue. Veuillez réessayer.',
    errorNetwork:
      "Impossible d'envoyer le formulaire. Vérifiez votre connexion et réessayez.",
    trust1: 'Réponse sous 4h ouvrées',
    trust2: 'Aucun engagement',
    trust3: 'Audit gratuit',
    successTitle: 'Demande reçue.',
    successDescPart1: "Un membre de l'équipe revient vers vous sous",
    successDescHighlight: '4h ouvrées',
    successDescPart2: 'avec une première analyse de votre flux.',
    successReset: '← Envoyer une autre demande',
    tabCall: 'Réserver un appel',
    tabCallHint: '30 min · en visio',
    tabQuote: 'Demander un devis',
    tabQuoteHint: '2 min · estimation chiffrée',
    callTitle: 'Choisissez votre créneau',
    callDesc:
      "30 minutes en visio avec un expert logistique. On analyse votre flux actuel et on vous dit franchement si Yaslan est le bon partenaire.",
    callLoading: 'Chargement du calendrier…',
    callFallback:
      "Le calendrier ne s'affiche pas ? Votre navigateur bloque peut-être le script. Ouvrez-le dans un nouvel onglet :",
  },
  blog: {
    badgeName: 'Blog Yaslan',
    badgeTopic: 'Logistique & e-commerce',
    heroTitleLine1: 'Le blog des e-commerçants qui',
    heroTitleHighlight: 'livrent mieux',
    heroSubtitle:
      'Conseils, études de cas et décryptages pour optimiser votre logistique, choisir les bons transporteurs et scaler votre e-commerce.',
    categories: {
      all: 'Tous',
      logistics: 'Logistique',
      ecommerce: 'E-commerce',
      delivery: 'Livraison',
      technology: 'Technologie',
      sustainability: 'Durabilité',
    },
    filterAll: 'Tous',
    countSingular: '{count} article',
    countPlural: '{count} articles',
    byline: 'Par {name}',
    readTime: '{n} min de lecture',
    readTimeShort: '{n} min',
    featured: 'À la une',
    readArticle: "Lire l'article",
    allArticlesTitle: 'Tous les articles',
    allArticlesCaption: 'Publiés chaque semaine',
    emptyState: "Aucun article dans cette catégorie pour l'instant.",
    newsletterBadge: 'Newsletter hebdomadaire',
    newsletterTitleLine1: 'Recevez nos meilleurs articles',
    newsletterTitleHighlight: 'directement dans votre inbox',
    newsletterCopy:
      'Un e-mail chaque semaine. Études de cas, benchmarks transporteurs et bonnes pratiques pour scaler votre e-commerce. Zéro spam.',
    newsletterEmailLabel: 'Adresse e-mail',
    newsletterPlaceholder: 'vous@entreprise.com',
    newsletterSubmit: "S'abonner",
    newsletterSubmitted: 'Inscrit !',
    newsletterPrivacy:
      'En vous inscrivant, vous acceptez notre politique de confidentialité. Désabonnement en un clic.',
    newsletterSocialProofPart1: 'Rejoint par',
    newsletterSocialProofCount: '1 200+',
    newsletterSocialProofPart2: 'e-commerçants',
    article: {
      notFoundTitle: 'Article introuvable',
      notFoundLink: '← Retour au blog',
      breadcrumbHome: 'Accueil',
      breadcrumbBlog: 'Blog',
      contentUnavailable:
        "Le contenu de cet article n'est pas encore disponible. Revenez bientôt !",
      relatedHeading: 'À lire ensuite',
      ctaBadge: 'Audit logistique · 30 min · gratuit',
      ctaTitleLead: 'Et si votre logistique',
      ctaTitleHighlight: 'disparaissait',
      ctaTitleTail: 'de votre quotidien ?',
      ctaCopy:
        "30 minutes pour comprendre votre flux. Une proposition tarifaire chiffrée sous 48 h. Une mise en route en moins d'une semaine.",
      ctaPrimary: 'Réserver un échange de 30 min',
      ctaSecondary: '← Tous les articles',
      trust1: 'Réponse sous 24 h ouvrées',
      trust2: 'Sans engagement',
    },
  },
  sectorsPage: {
    breadcrumbHome: 'Accueil',
    breadcrumbCurrent: 'Secteurs',
    badge: 'Secteurs · Logistique sur-mesure',
    h1Lead: 'Une logistique pensée pour',
    h1Highlight: 'votre secteur',
    intro:
      'Mode, cosmétique, électronique, jardin & extérieur, maison & décoration, parfumerie — chaque secteur impose ses contraintes : conformité, fragilité, saisonnalité, traçabilité, unboxing. Yaslan adapte ses procédures, son emballage et son réseau transporteur à votre marché pour vous donner un avantage opérationnel mesurable.',
    number1Value: '6',
    number1Label: 'Secteurs maîtrisés',
    number2Value: '30+',
    number2Label: 'Marques accompagnées',
    number3Value: '0 €',
    number3Label: 'Frais cachés',
    gridTitleLead: 'Six secteurs,',
    gridTitleHighlight: 'une expertise dédiée',
    gridCaption:
      'Cliquez sur votre secteur pour découvrir notre approche, nos garanties et les réponses concrètes que nous apportons à vos contraintes opérationnelles.',
    cardCta: 'Découvrir',
    whyBadge: 'Pourquoi un 3PL spécialisé ?',
    whyTitleLead: 'Un 3PL générique',
    whyTitleHighlight: 'vous ralentit',
    whyPara1:
      "Externaliser sa logistique e-commerce à un opérateur 3PL n'a de sens que si cet opérateur connaît votre marché. Un prestataire qui traite indifféremment du textile et de l'électronique applique des procédures moyennes qui produisent des résultats moyens — taux de retours mal géré, casse en hausse, conformité douteuse.",
    whyPara2:
      "Yaslan est un 3PL e-commerce belge qui a structuré ses procédures par secteur : filière ADR pour la parfumerie, traçabilité par lot pour la cosmétique, sérialisation IMEI pour l'électronique, capacité élastique pour les drops mode, manutention lourde pour le jardin, calage anti-choc pour la décoration. Ce sont des compétences distinctes, pas un même processus repeint.",
    whyPara3:
      "Résultat : un coût logistique maîtrisé, sans frais cachés, des taux de casse divisés par cinq sur les produits sensibles, et une expérience client qui respecte le ton de votre marque — du carton au transporteur.",
    ctaBadge: 'Audit logistique · 30 min · gratuit',
    ctaTitleLead: 'Et si votre logistique',
    ctaTitleHighlight: 'disparaissait',
    ctaTitleTail: ' de votre quotidien ?',
    ctaCopy:
      '30 minutes pour comprendre votre flux. Une proposition tarifaire chiffrée sous 48h. Une mise en route en moins d\'une semaine.',
    ctaPrimary: 'Réserver un échange de 30 min',
    ctaSecondary: 'En savoir plus sur Yaslan',
    trust1: 'Réponse sous 24h ouvrées',
    trust2: 'Sans engagement',
    trust3: '200+ marques nous font confiance',
  },
  sectorPage: {
    notFoundTitle: 'Secteur introuvable',
    notFoundLink: '← Voir tous les secteurs',
    breadcrumbHome: 'Accueil',
    breadcrumbSectors: 'Secteurs',
    badgeSuffix: ' · 3PL spécialisé',
    challengesHeadingLead: 'Les défis logistiques de',
    challengesConstat: 'Le constat',
    challengesResponse: 'Notre réponse',
    flowHeadingLead: 'Le flux Yaslan pour',
    flowIntro:
      'Trois stations orchestrées par notre équipe et nos systèmes — chaque pièce passe par les contrôles spécifiques à votre secteur, sans perte de temps.',
    promiseKicker: 'Notre engagement',
    statsBadge: 'Engagements chiffrés',
    statsHeadingLead: 'Pourquoi choisir Yaslan pour',
    seasonalHeadingLead: 'Vos pics saisonniers,',
    seasonalHeadingHighlight: 'absorbés sans rupture',
    seasonalIntro:
      "Capacité élastique et renforts opérationnels planifiés à l'avance — votre saison haute ne devient jamais votre point de rupture.",
    faqHeadingLead: 'Questions fréquentes —',
    faqHeadingHighlight: 'logistique de {sector}',
    otherSectors: 'Autres secteurs',
    ctaBadge: 'Audit {sector} · 30 min · gratuit',
    ctaTitleLead: 'Et si votre logistique',
    ctaTitleHighlight: 'disparaissait',
    ctaTitleTail: ' de votre quotidien ?',
    ctaCopy:
      "30 minutes pour comprendre votre catalogue {sector} et votre saisonnalité. Une proposition tarifaire chiffrée sous 48h. Une mise en route en moins d'une semaine.",
    ctaPrimary: 'Réserver un échange de 30 min',
    ctaSecondary: '← Tous les secteurs',
    trust1: 'Réponse sous 24h ouvrées',
    trust2: 'Sans engagement',
    trust3: '200+ marques nous font confiance',
  },
  servicePage: {
    seoTitle: '{service} e-commerce en Belgique | Yaslan 3PL',
    notFoundTitle: 'Service introuvable',
    backToHome: '← Retour à l\'accueil',
    breadcrumbHome: 'Accueil',
    flowHeadingLead: 'Comment fonctionne notre',
    flowIntro:
      'Trois stations orchestrées par notre équipe et nos systèmes — chaque étape passe par les contrôles spécifiques au service, sans perte de temps.',
    statsBadge: 'Engagements chiffrés',
    statsHeadingLead: 'Trois nombres qui',
    statsHeadingHighlight: 'changent tout',
    promiseKicker: 'Notre promesse',
    featuresHeadingLead: 'Tout ce qui est',
    featuresHeadingHighlight: 'inclus',
    faqHeadingLead: 'Questions fréquentes —',
    otherServicesHeading: 'Et aussi :',
    otherServicesLink: 'Découvrir',
    ctaBadge: 'Audit {service} · 30 min · gratuit',
    ctaTitleLead: 'Et si votre logistique',
    ctaTitleHighlight: 'disparaissait',
    ctaTitleTail: ' de votre quotidien ?',
    ctaCopy:
      '30 minutes pour comprendre votre flux. Une proposition tarifaire chiffrée sous 48 h. Une mise en route en moins d\'une semaine.',
    ctaPrimary: 'Réserver un échange de 30 min',
    trust1: 'Réponse sous 24 h ouvrées',
    trust2: 'Sans engagement',
    trust3: '30+ marques nous font confiance',
  },
  cookieBanner: {
    dialogAriaLabel: 'Bandeau de consentement aux cookies',
    eyebrow: 'Cookies',
    bannerTitle: 'Votre vie privée, vos choix',
    bannerBody:
      "Nous utilisons uniquement des cookies strictement nécessaires au fonctionnement du site. Avec votre accord, nous mesurons aussi l'audience de manière anonyme pour améliorer notre contenu.",
    learnMore: 'En savoir plus',
    customize: 'Personnaliser',
    reject: 'Refuser',
    accept: 'Accepter',
    closeAria: 'Fermer',
    prefsEyebrow: 'Préférences cookies',
    prefsTitle: 'Gérer mes cookies',
    prefsIntro:
      'Choisissez les catégories de cookies que vous autorisez. Vos préférences sont conservées 6 mois et peuvent être modifiées à tout moment.',
    necessaryTitle: 'Strictement nécessaires',
    necessaryDesc:
      'Indispensables au fonctionnement du site (mémorisation de vos choix de consentement). Toujours actifs.',
    necessaryBadge: 'Actif',
    analyticsTitle: "Mesure d'audience",
    analyticsDesc:
      'Nous aide à comprendre comment notre site est utilisé, de manière anonyme. Aucun profilage publicitaire.',
    rejectAll: 'Tout refuser',
    save: 'Enregistrer',
    acceptAll: 'Tout accepter',
    prefsFooterPart1: 'En savoir plus dans notre',
    prefsFooterLink: 'Politique cookies',
  },
  breadcrumb: {
    adr: 'ADR',
    afsca: 'AFSCA',
    home: 'Accueil',
    about: 'À propos',
    sectors: 'Secteurs',
    blog: 'Blog',
    contact: 'Contact',
    cookies: 'Politique cookies',
    legal: 'Mentions légales',
    privacy: 'Politique de confidentialité',
    terms: 'CGV',
  },
  adrPage: {
    // ── Hero ──
    badge: 'Marchandises dangereuses · ADR',
    h1Lead: 'Stockez et expédiez vos',
    h1Highlight: 'marchandises dangereuses',
    h1Tail: ' e-commerce.',
    subhead:
      "Batteries au lithium, aérosols, inflammables, corrosifs, cosmétiques alcoolisés… Nous détenons un permis de stockage ADR et expédions vos produits sensibles partout en Europe — là où la plupart des 3PL et des logiciels e-commerce refusent.",
    ctaPrimary: 'Audit gratuit',
    reassure: 'Réponse sous 4h ouvrées · Sans abonnement',
    // ── Hook différenciant ──
    hook: {
      eyebrow: 'Ce qui nous distingue',
      title: 'Ce que la plupart des 3PL refusent de gérer',
      lead: "La majorité des prestataires logistiques et des plateformes e-commerce bloquent les marchandises dangereuses dès la fiche produit. Nous, nous les stockons et les expédions.",
      points: [
        'Un entrepôt avec permis de stockage ADR, pas une simple étagère.',
        'Des transporteurs agréés ADR pour vos envois B2B en volume.',
        'Un cadre conforme, du stockage à la livraison finale.',
      ],
    },
    // ── Scope OUI / NON ──
    scope: {
      eyebrow: 'Périmètre',
      title: 'Ce que nous gérons, ce que nous ne gérons pas',
      statement:
        "Marchandise dangereuse ne veut pas dire marchandise refusée : si elle entre dans notre périmètre ADR, nous la stockons et l'expédions — sinon, on vous le dit clairement.",
      yesTitle: 'Nous stockons & expédions',
      yes: [
        'Batteries et piles au lithium',
        'Aérosols et sprays sous pression',
        'Liquides inflammables',
        'Produits corrosifs',
        'Cosmétiques alcoolisés (parfums…)',
        "Produits d'entretien",
      ],
      noTitle: 'Hors périmètre',
      no: [
        'Explosifs (classe 1)',
        'Matières radioactives (classe 7)',
      ],
      note: "Un doute sur votre produit ? Envoyez-nous sa fiche de données de sécurité (FDS) : on vous répond clairement, oui ou non.",
    },
    // ── Comment ça marche ──
    how: {
      eyebrow: 'Comment ça marche',
      title: "Du stockage à l'expédition, deux flux maîtrisés",
      steps: [
        {
          title: 'Stockage conforme',
          desc: 'Vos marchandises dangereuses sont stockées sous permis ADR, séparées et signalées selon leur classe.',
        },
        {
          title: 'Envoi B2C',
          desc: "Un produit, une destination : on expédie via les transporteurs de notre réseau habituel, dans les quantités autorisées.",
        },
        {
          title: 'Envoi B2B en volume',
          desc: 'Au-delà de ~2 palettes, on passe par un transporteur agréé ADR : DSV.',
        },
      ],
    },
    // ── Conformité & garanties ──
    compliance: {
      eyebrow: 'Conformité & garanties',
      title: 'Un cadre réglementaire, pas une zone grise',
      items: [
        {
          title: 'Permis de stockage ADR',
          desc: 'Notre entrepôt est autorisé à stocker des marchandises dangereuses e-commerce dans les classes que nous gérons.',
        },
        {
          title: 'Transporteurs agréés',
          desc: 'Pour le B2B en volume, nous travaillons avec DSV, agréé pour le transport ADR.',
        },
        {
          title: 'Emballage & étiquetage',
          desc: 'Marquage, étiquettes de danger et documents de transport conformes à chaque envoi.',
        },
        {
          title: 'Séparation des classes',
          desc: 'Les produits incompatibles sont stockés séparément pour éviter tout risque.',
        },
      ],
    },
    // ── FAQ (longue traîne SEO) ──
    faqEyebrow: 'FAQ',
    faqTitle: 'Vos questions sur le stockage ADR',
    faq: [
      {
        q: "Qu'est-ce que l'ADR et qui est concerné en e-commerce ?",
        a: "L'ADR est l'accord européen relatif au transport international des marchandises dangereuses par route. En e-commerce, il concerne tous les produits classés dangereux : batteries au lithium, aérosols, parfums, produits inflammables ou corrosifs… Dès qu'un de ces articles est stocké puis expédié, un cadre ADR s'applique.",
      },
      {
        q: 'Pouvez-vous stocker des batteries au lithium pour ma boutique en ligne ?',
        a: "Oui. Les batteries et piles au lithium font partie des marchandises dangereuses que nous stockons sous permis ADR et que nous expédions, en B2C comme en B2B, dans le respect des quantités et emballages réglementaires.",
      },
      {
        q: 'Quels produits dangereux ne pouvez-vous pas gérer ?',
        a: "Nous ne gérons pas les explosifs (classe 1) ni les matières radioactives (classe 7), qui sortent du périmètre e-commerce. Pour tout le reste — lithium, aérosols, inflammables, corrosifs, cosmétiques alcoolisés — envoyez-nous la fiche de données de sécurité et nous validons la prise en charge.",
      },
      {
        q: 'Comment expédiez-vous les marchandises dangereuses en B2C ?',
        a: "Pour un envoi unique (un produit vers une destination), nous expédions via les transporteurs de notre réseau habituel, dans les limites de quantité prévues pour les colis de marchandises dangereuses.",
      },
      {
        q: 'Et pour les volumes B2B (plusieurs palettes) ?',
        a: "Au-delà d'environ deux palettes, nous passons par un transporteur agréé ADR — DSV — qui dispose des moyens et certifications nécessaires au transport de marchandises dangereuses en volume.",
      },
      {
        q: 'Faut-il un emballage spécifique pour les produits ADR ?',
        a: "Oui. Chaque envoi de marchandises dangereuses requiert un emballage homologué, un marquage et des étiquettes de danger conformes, ainsi que les documents de transport adéquats. Nous nous en chargeons.",
      },
      {
        q: 'Livrez-vous des marchandises dangereuses partout en Europe ?',
        a: "Oui, nous expédions en Europe, au Royaume-Uni et en Suisse. Les modalités exactes dépendent de la classe du produit, de la quantité et de la destination — nous validons chaque cas lors de l'audit.",
      },
    ],
    // ── Libellés d'animations (composants bespoke) ──
    anim: {
      diamond: {
        badge: 'Classes gérées',
        classes: ['Lithium', 'Aérosols', 'Inflammables', 'Corrosifs'],
      },
      sort: {
        badge: 'Tri de conformité',
        accepted: 'Accepté',
        rejected: 'Hors périmètre',
      },
      split: {
        badge: 'Deux flux',
        stored: 'Stock ADR',
        b2c: 'B2C',
        b2cDesc: '1 produit → 1 client',
        b2b: 'B2B',
        b2bDesc: 'Volumes · palettes',
        carriers: 'DSV',
      },
    },
  },
  afscaPage: {
    // ── Hero ──
    badge: 'Denrées alimentaires · AFSCA',
    h1Lead: 'Votre stockage alimentaire,',
    h1Highlight: 'enregistré AFSCA',
    h1Tail: '.',
    subhead:
      "Compléments, boissons non périssables, thé, épicerie sèche… Nous sommes enregistrés auprès de l'AFSCA pour le stockage à température ambiante, avec rotation FEFO, gestion des dates et traçabilité par lot.",
    ctaPrimary: 'Audit gratuit',
    reassure: 'Réponse sous 4h ouvrées · Sans abonnement',
    // ── Hook différenciant ──
    hook: {
      eyebrow: 'Ce qui nous distingue',
      title: 'La logistique food que beaucoup de 3PL évitent',
      lead: "Stocker des denrées alimentaires impose un cadre que peu de prestataires e-commerce assument. Nous, oui — pour les produits à température ambiante.",
      points: [
        "Enregistrement AFSCA pour le stockage à température ambiante.",
        'Rotation FEFO et gestion des DLC/DDM, pas du premier-entré-premier-sorti aveugle.',
        'Traçabilité par lot et capacité de rappel.',
      ],
    },
    // ── Scope OUI / NON ──
    scope: {
      eyebrow: 'Périmètre',
      title: 'Ce que nous stockons, ce que nous ne stockons pas',
      yesTitle: 'Nous stockons (ambiant)',
      yes: [
        'Compléments alimentaires',
        'Boissons non périssables (eau…)',
        'Thé et infusions',
        'Épicerie sèche',
        'Produits préemballés ambiants',
      ],
      noTitle: 'Hors périmètre',
      no: [
        'Produits frais (0–8 °C)',
        'Surgelés',
        'Aliments pour animaux',
      ],
      note: "Nous stockons uniquement à température ambiante : pas de chaîne du froid, pas de surgelé, pas de petfood.",
    },
    // ── Gestion du stock ──
    how: {
      eyebrow: 'Gestion du stock',
      title: 'Une gestion food, pas une simple mise en carton',
      steps: [
        {
          title: 'Réception & contrôle',
          desc: "À l'entrée, on enregistre les lots et les dates de péremption (DLC/DDM).",
        },
        {
          title: 'Rotation FEFO',
          desc: 'First Expired, First Out : les produits dont la date approche partent en premier.',
        },
        {
          title: 'Traçabilité par lot',
          desc: 'Chaque expédition est rattachée à son lot — indispensable en cas de rappel.',
        },
      ],
    },
    // ── Conformité & garanties ──
    compliance: {
      eyebrow: 'Conformité & garanties',
      title: 'Le cadre AFSCA, concrètement',
      items: [
        {
          title: 'Enregistrement AFSCA',
          desc: "Nous sommes enregistrés auprès de l'AFSCA pour le stockage de denrées alimentaires à température ambiante.",
        },
        {
          title: 'FEFO & gestion des dates',
          desc: 'Rotation pilotée par les DLC/DDM pour éviter les pertes et livrer des produits dans leur durée de vie.',
        },
        {
          title: 'Traçabilité par lot',
          desc: "Suivi des lots de la réception à l'expédition, pour réagir vite en cas de retrait ou de rappel.",
        },
        {
          title: 'Hygiène & séparation',
          desc: 'Stockage propre, sec et organisé, séparé des marchandises non alimentaires.',
        },
      ],
    },
    // ── FAQ (longue traîne SEO) ──
    faqEyebrow: 'FAQ',
    faqTitle: 'Vos questions sur le stockage alimentaire',
    faq: [
      {
        q: "Qu'est-ce que l'AFSCA et pourquoi est-ce important pour vendre de l'alimentaire en ligne ?",
        a: "L'AFSCA est l'Agence fédérale belge pour la sécurité de la chaîne alimentaire. Toute entreprise qui stocke ou manipule des denrées alimentaires doit être connue d'elle. Confier votre stock à un prestataire enregistré AFSCA, c'est garantir que vos produits sont entreposés dans un cadre contrôlé.",
      },
      {
        q: 'Quels produits alimentaires pouvez-vous stocker ?',
        a: "Nous stockons les denrées à température ambiante : compléments alimentaires, boissons non périssables, thé et infusions, épicerie sèche et produits préemballés. Tout ce qui ne nécessite ni froid ni congélation.",
      },
      {
        q: 'Stockez-vous des produits frais ou surgelés ?',
        a: "Non. Notre enregistrement couvre le stockage à température ambiante uniquement. Nous ne gérons ni la chaîne du froid (0–8 °C), ni les surgelés, ni les aliments pour animaux.",
      },
      {
        q: 'Comment gérez-vous les dates de péremption (DLC/DDM) ?',
        a: "Dès la réception, nous enregistrons les dates et appliquons une rotation FEFO (First Expired, First Out) : les produits dont la date approche sont expédiés en priorité, ce qui réduit les pertes et garantit des produits dans leur durée de vie.",
      },
      {
        q: 'Assurez-vous la traçabilité par lot ?',
        a: "Oui. Chaque produit est rattaché à son lot, de la réception à l'expédition. En cas de retrait ou de rappel, nous identifions rapidement les commandes concernées.",
      },
      {
        q: 'Que se passe-t-il en cas de rappel produit ?',
        a: "Grâce à la traçabilité par lot, nous pouvons isoler le stock concerné et identifier les commandes ayant reçu le lot visé, pour exécuter un retrait ou un rappel dans les meilleurs délais.",
      },
      {
        q: 'Quelle est la différence entre DLC et DDM ?',
        a: "La DLC (date limite de consommation, « à consommer jusqu'au ») concerne les produits périssables ; la DDM (date de durabilité minimale, « à consommer de préférence avant ») concerne les produits stables comme l'épicerie sèche. Nous gérons les deux dans notre rotation.",
      },
    ],
    // ── Libellés d'animations (composants bespoke) ──
    anim: {
      shield: {
        badge: 'AFSCA',
        label: 'Conforme',
      },
      gauge: {
        badge: 'Température',
        ambient: 'Ambiant',
        chilled: 'Frais',
        frozen: 'Surgelé',
      },
      fefo: {
        badge: 'FEFO',
        title: 'First Expired, First Out',
        next: 'Part en premier',
        lot: 'Lot tracé',
      },
    },
  },
  devisWizard: {
    badge: 'Devis & audit gratuit',
    title: 'Estimez vos besoins logistiques',
    subtitle:
      'En 1 minute : recevez votre estimation personnalisée et réservez 15 min avec un expert Yaslan.',
    progress: { step1: 'Produits', step2: 'Volumes', step3: 'Coordonnées', step4: 'Rendez-vous' },
    nav: { prev: 'Précédent', next: 'Suivant', seeEstimate: 'Voir mon estimation' },
    step1: {
      title: 'Vos produits',
      sectorLabel: 'Votre secteur ?',
      sourcingLabel: 'Où sont fabriqués / sourcés vos produits ?',
      basketLabel: 'Panier moyen',
    },
    step2: {
      title: 'Vos volumes & livraison',
      ordersLabel: 'Commandes par mois',
      itemsLabel: 'Articles moyens par colis',
      weightLabel: "Poids moyen d'un article",
      splitLabel: 'Répartition de livraison souhaitée',
      splitHome: 'Domicile',
      splitPickup: 'Point relais',
      zonesLabel: 'Zones de livraison',
    },
    step3: {
      title: 'Vos coordonnées',
      nameLabel: 'Nom complet',
      namePh: 'Jean Dupont',
      emailLabel: 'E-mail professionnel',
      emailPh: 'vous@entreprise.com',
      phoneLabel: 'Téléphone',
      phonePh: '+32 4XX XX XX XX',
      websiteLabel: 'Site web',
      websitePh: 'votre-boutique.com',
      platformLabel: 'Plateforme e-commerce',
      platformPh: 'Choisissez…',
      privacy:
        'Vos informations servent uniquement à préparer votre devis. Aucune revente, aucun spam.',
    },
    sectors: {
      mode: 'Mode & Textile',
      cosmetique: 'Cosmétique & Beauté',
      parfumerie: 'Parfumerie',
      maison: 'Maison & Déco',
      jardin: 'Jardin & Extérieur',
      electronique: 'Électronique',
      food: 'Compléments / Food',
      autre: 'Autre',
    },
    sourcing: {
      import: 'Importés (Asie / Chine)',
      ue: 'UE / Europe',
      local: 'Belgique / local',
      mix: 'Mix',
    },
    zones: {
      be: 'Belgique',
      eu: 'Europe',
      uk: 'Royaume-Uni',
      ch: 'Suisse',
      world: 'Monde',
    },
    platforms: {
      shopify: 'Shopify',
      woocommerce: 'WooCommerce',
      prestashop: 'PrestaShop',
      magento: 'Magento',
      amazon: 'Amazon',
      other: 'Autre / aucune',
    },
    units: {
      basket: '€',
      orders: 'commandes / mois',
      items: 'articles',
      weight: 'g',
    },
    booking: {
      teaserTitle: 'Votre estimation personnalisée est prête',
      teaserDesc:
        'Réservez 30 minutes avec un expert pour la recevoir en détail et obtenir votre devis sur-mesure.',
      calFallback:
        "Un souci pour afficher le calendrier ? Ouvrez-le dans un nouvel onglet.",
      bookedTitle: "C'est réservé !",
      bookedDesc:
        'On a bien reçu votre brief — on prépare votre estimation pour le rendez-vous. À très vite !',
    },
    error: {
      required: 'Merci de remplir les champs requis (nom, e-mail, téléphone).',
      briefFailed: 'Votre demande a bien été prise en compte ; réservez votre créneau ci-dessous.',
    },
  },
  seo: {
    adr: {
      title: 'Stockage ADR — Marchandises dangereuses e-commerce — Yaslan',
      description:
        'Yaslan stocke et expédie vos marchandises dangereuses e-commerce (batteries lithium, aérosols, inflammables…) avec permis de stockage ADR. B2C tout transporteur, B2B via DSV.',
    },
    afsca: {
      title: 'Stockage AFSCA — Logistique alimentaire ambiante — Yaslan',
      description:
        'Yaslan, enregistré AFSCA, stocke vos produits alimentaires à température ambiante (compléments, boissons, épicerie sèche) avec rotation FEFO, gestion DLC et traçabilité par lot.',
    },
    home: {
      title: 'Yaslan — Votre logistique e-commerce 3PL en Belgique',
      description:
        'Yaslan, prestataire logistique 3PL e-commerce en Belgique. Stockage, pick & pack, expédition 24h, gestion des retours. Sans abonnement.',
    },
    about: {
      title: 'À propos de Yaslan — Logistique e-commerce 3PL en Belgique',
      description:
        "Découvrez Yaslan : prestataire logistique 3PL belge spécialisé dans l'e-commerce. Notre mission, notre méthode en 4 étapes et notre engagement pour faire disparaître la logistique de votre quotidien.",
    },
    contactPage: {
      title: 'Contactez Yaslan — Logistique 3PL e-commerce en Belgique',
      description:
        'Parlez à notre équipe logistique francophone. Réponse sous 4h ouvrées, audit gratuit de votre flux e-commerce. Basé à Willebroek, livraisons en Europe, UK et Suisse.',
    },
    blog: {
      title: 'Blog logistique e-commerce — Conseils & tendances — Yaslan',
      description:
        'Conseils pratiques, analyses de tendances et retours terrain sur la logistique e-commerce, le fulfillment 3PL et la gestion des retours en Europe.',
    },
    sectors: {
      title: 'Logistique e-commerce par secteur — Yaslan',
      description:
        'Solutions 3PL adaptées à votre secteur : mode, cosmétique, électronique, jardin & extérieur, maison & décoration, parfumerie. Stockage, préparation et expédition 24h en Europe depuis la Belgique.',
    },
  },
} as const

export type Messages = typeof fr

export type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends string
    ? string
    : T[K] extends object
      ? DeepPartial<T[K]>
      : T[K]
}
